var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M8.293 5.6a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.413l-6 6A1 1 0 1 1 8.293 17.6l5.293-5.293-5.293-5.293a1 1 0 0 1 0-1.414Z",
  clipRule: "evenodd"
})));
SvgChevronRight.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRight);
export default ForwardRef;